module.exports = require("@apollo/client/link/persisted-queries");